import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DateInterface {
  dateSelected: Date | null;
}

const initialState: DateInterface = {
  dateSelected: null,
};

const datePickerAlert = createSlice({
  name: "datepickeralert",
  initialState,
  reducers: {
    datePickerSetDate: (state, action: PayloadAction<Date | null>) => {
      state.dateSelected = action.payload;
    },
  },
});

export const { datePickerSetDate } = datePickerAlert.actions;

export default datePickerAlert.reducer;
